import * as Yup from 'yup'
import Phone from '../services/Phone'

const ownerDataValidator = Yup.object ({
  owner: Yup.string ()
    .required ('Digite um nome')
    .min (4, 'O nome deve conter no minimo 4 caracteres')
    .max (128, 'O nome deve conter até 128 caracteres'),
    
  owner_email: Yup.string ()
    .required ('Digite o e-mail do responsável')
    .email ('Insira um e-mail válido')
    .max (128, 'O e-mail deve conter até 128 caracteres'),

  owner_phone: Yup.string ()
    .required ('Digite o celular')
    .test ('validCellphone', 'Insira um celular válido', function (value) {
      if (!value) return true
      return Phone.isValidPhoneNumber (value)
    })
})

export default ownerDataValidator
